import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FULL_TESTIMONIALS } from '../../data/content';
function getInitials(name: string) {
  return name.split(' ').map(part => part.charAt(0)).join('').slice(0, 2);
}
export function Testimonials() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-242" data-mp="3r93hz1pj4eyr">
      <div className="mx-auto max-w-5xl" data-id="element-243" data-mp="1hi7k5xkwn6">
        <Reveal className="text-center" data-id="element-244" data-mp="oaogz5e33z">
          <SectionBadge data-id="element-245" data-mp="42t1l7y7olmx">Testimonios</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-246" data-mp="41hx15wxz9ur">
            Lo que dicen <span className="u-lime" data-id="element-247" data-mp="8zt8tm6srufm">+500 profesoras</span>
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-2" data-id="element-248" data-mp="e07j7avvfggt">
          {FULL_TESTIMONIALS.map((testimonial, index) => <Reveal key={testimonial.name} delay={index % 2 * 80} as="article" data-id="element-249" data-mp="2av3p2ap3ppl0" data-mpi={index}>
              <div className="flex h-full flex-col rounded-2xl border border-ink-line bg-ink p-5 sm:p-6" data-id="element-250" data-mp="2fsvp5rzwgi0a">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-251" data-mp="1sm40m7blislg">
                  {Array.from({
                length: 5
              }).map((_, starIndex) => <StarIcon key={starIndex} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-252" data-mp="1iu7vwdf08489" data-mpi={starIndex} />)}
                </span>

                <p className="mt-3.5 flex-1 text-sm leading-relaxed text-snow sm:text-base" data-id="element-253" data-mp="1eufpo7d32a62">
                  “{testimonial.quote}”
                </p>

                <div className="mt-5 flex items-center gap-3 border-t border-ink-line pt-4" data-id="element-254" data-mp="26kk4zrlzk70f">
                  <span aria-hidden="true" className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-rose text-xs font-extrabold text-snow" data-id="element-255" data-mp="22ip6euvfw7qc">
                    {getInitials(testimonial.name)}
                  </span>
                  <span data-id="element-256" data-mp="r4bkhvk8y2cy">
                    <span className="block text-sm font-bold text-snow" data-id="element-257" data-mp="r4v035mfcent">{testimonial.name}</span>
                    <span className="block text-xs text-snow-dim" data-id="element-258" data-mp="m35pts71050s">{testimonial.city}</span>
                  </span>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}